import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { UserRoleService } from './services/userRole.service';

@Injectable()
export class ConditionalMsalInterceptor implements HttpInterceptor {
  constructor(
    private msalService: MsalService,
    private userService: UserRoleService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (req.url.includes('auth/login')) {
      return next.handle(req);
    }
    if (this.msalService.instance.getAllAccounts().length > 0) {
      const activeAccount = this.msalService.instance.getActiveAccount();
      return from(
        this.msalService.instance.acquireTokenSilent({
          scopes: environment.apiConfig.scopes,
          account: activeAccount,
        }),
      ).pipe(
        switchMap((result) => {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${result.accessToken}`,
            },
          });
          return next.handle(authReq);
        }),
      );
    }

    const localToken = this.userService.getJWT();
    if (localToken) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${localToken}`,
        },
      });
      return next.handle(authReq);
    }

    return next.handle(req);
  }
}
